import { BaseCalculatorTab } from "../../../../tabs/calculatorResults/baseCalculatorTab";
import { OrderItem } from "../../../../../../objects/orders/orderItem";
import { Component, Input, OnInit } from "@angular/core";
import { Order } from "../../../../../../objects/orders/order";
import { OrderOptions } from "../../../../../../objects/orders/orderOptions";
import { CalculatorHelper } from "../../../../../../common/helpers/calculatorHelper";

@Component({
    selector: "usa-results-v2",
    templateUrl: "./usa-results-v2.component.html",
    moduleId: module.id.toString()
})
export class USAResultsV2Component extends BaseCalculatorTab implements OnInit {

    @Input()
    public order: Order;
    @Input()
    public orderItem: OrderItem;

    public get currency(): string {
       return CalculatorHelper.getCurrencyName(this.order);
    }

    public get isVehicle(): boolean {
        return CalculatorHelper.isVehicle(this.order);
    }

    public ngOnInit(): void {

    }
}


// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/result-tab/usa/usa-results-v2.component.ts